module.exports = __webpack_public_path__ + "img/brand_logo.1c3b6ae7.svg";